export const CLONE_AND_EDIT = 'campaignsPage/CLONE_AND_EDIT';

export const REMOVE = 'campaignsPage/REMOVE';
